import apiClient from './client';

export interface Notification {
  id: number;
  user_id: number;
  category: string;
  type?: string; // Backend sends 'type', mapped to 'category'
  title: string;
  message: string;
  is_read: boolean;
  read_at?: string;
  metadata?: any;
  entity_type?: string;
  entity_id?: number;
  created_at: string;
  /** Project/context (lead project or account name) for grouping and filtering */
  project?: string | null;
}

export const notificationsApi = {
  getAll: async (
    unreadOnly?: boolean,
    limit?: number,
    project?: string
  ): Promise<Notification[]> => {
    const params: Record<string, string> = {};
    if (unreadOnly) params.unreadOnly = 'true';
    if (limit) params.limit = limit.toString();
    if (project) params.project = project;
    const response = await apiClient.get<{ success: boolean; data: Notification[] }>(
      '/notifications',
      { params }
    );
    return Array.isArray(response.data?.data) ? response.data.data : [];
  },
  getUnreadCount: async (): Promise<number> => {
    const response = await apiClient.get<{ success: boolean; data: { count: number } }>('/notifications/unread-count');
    const count = response.data?.data?.count;
    return typeof count === 'number' ? count : 0;
  },
  markAsRead: async (id: number): Promise<void> => {
    await apiClient.patch(`/notifications/${id}/read`);
  },
  markAllAsRead: async (): Promise<void> => {
    await apiClient.patch('/notifications/read-all');
  },
  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/notifications/${id}`);
  },
  clearAll: async (): Promise<void> => {
    await apiClient.delete('/notifications/clear-all');
  },
};
